// =============================================================================
// UrlListEditor — repeatable URL list with add / remove
// =============================================================================
// Props: { value: string[], onChange: (string[]) => void, placeholder?, label? }
// Note: drag-to-reorder is v2. Order = insertion order.
// Empty strings are allowed in local state. Caller filters at save time.

import { useRef } from 'react';

const URL_RX = /^https?:\/\/.+/;

export default function UrlListEditor({ value = [], onChange, placeholder = 'https://…', label }) {
  const inputRefs = useRef([]);

  function update(i, v) {
    const next = [...value];
    next[i] = v;
    onChange(next);
  }

  function remove(i) {
    onChange(value.filter((_, idx) => idx !== i));
  }

  function add() {
    const next = [...value, ''];
    onChange(next);
    setTimeout(() => inputRefs.current[next.length - 1]?.focus(), 0);
  }

  return (
    <div>
      {label && <span className="label-dark block mb-2">{label}</span>}

      <div className="space-y-2">
        {value.map((url, i) => {
          const invalid = url.trim().length > 0 && !URL_RX.test(url);
          return (
            <div key={i} className="flex gap-2 items-start">
              <div className="flex-1">
                <input
                  ref={el => { inputRefs.current[i] = el; }}
                  type="url"
                  value={url}
                  onChange={e => update(i, e.target.value)}
                  placeholder={placeholder}
                  className={`input${invalid ? ' border-red-400 focus:ring-red-400' : ''}`}
                />
                {invalid && (
                  <p className="text-xs text-red-600 mt-1">Enter a valid URL starting with http:// or https://</p>
                )}
              </div>
              <button
                type="button"
                onClick={() => remove(i)}
                aria-label="Remove"
                className="mt-2.5 text-silver-mute hover:text-red-500 transition-colors text-base leading-none"
              >
                ✕
              </button>
            </div>
          );
        })}
      </div>

      <button
        type="button"
        onClick={add}
        className="mt-3 w-full text-sm font-bold text-mid-green border border-dashed border-mid-green rounded-md py-2 hover:bg-mid-green/5 transition-colors"
      >
        + Add video URL
      </button>
    </div>
  );
}
